"use strict";
// Copyright © 2021 Move Closer
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var TeaserBoxModuleForm_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeaserBoxModuleForm = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
const debounce_1 = __importDefault(require("lodash/debounce"));
const merge_1 = __importDefault(require("lodash/merge"));
const vue_slicksort_1 = require("vue-slicksort");
const backoffice_1 = require("../../dsl/backoffice");
const services_1 = require("../../services");
const form_1 = require("../_abstract/form");
const form_2 = require("../_components/form");
const _contracts_1 = require("../_contracts");
const form_3 = require("../_components/ListSelector/form");
const TeaserBox_helpers_1 = require("./TeaserBox.helpers");
const TeaserBox_contracts_1 = require("./TeaserBox.contracts");
const TeaserBox_config_1 = require("./TeaserBox.config");
/**
 * TODO:
 *   - Fix order of properties/methods/getters/setters.
 *   - Add missing JSDoc blocks.
 *
 * Component that contains a complete questionnaire needed to **EDIT** the `TeaserBox`'s contents.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Olga Milczek <olga.milczek@movecloser.pl>
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
let TeaserBoxModuleForm = TeaserBoxModuleForm_1 = class TeaserBoxModuleForm extends form_1.AbstractModuleForm {
    constructor() {
        super(...arguments);
        this.DashmixIconName = backoffice_1.DashmixIconName;
        this.versionsWithExtendedRows = [
            TeaserBox_contracts_1.TeaserBoxVersion['6S-thumbnails-list'],
            TeaserBox_contracts_1.TeaserBoxVersion['6S-big-thumbnails-list'],
            TeaserBox_contracts_1.TeaserBoxVersion['6S-text-list'],
            TeaserBox_contracts_1.TeaserBoxVersion['6T-text-list']
        ];
        this.newTab = {
            label: '',
            list: null,
            listType: form_2.ListSelectionMode.Default,
            readMoreLink: null,
            allowDuplicates: false,
            startFromBeginning: false
        };
        /**
         * @see versionWithoutReadMore
         */
        this.versionWithoutReadMore = TeaserBox_config_1.versionWithoutReadMore;
        /**
         * @inheritDoc
         * @override
         */
        this.initialContent = TeaserBoxModuleForm_1.getInitialContent();
    }
    /**
     * @inheritDoc
     */
    get articlesCount() {
        return typeof this._version !== 'undefined'
            ? TeaserBox_helpers_1.getArticlesCount(this._version, this._content.tabs.length)
            : undefined;
    }
    /**
     * Determines the number of articles required (and rendered)
     * by the module for every single tab.
     */
    get articlesCountPerTab() {
        return typeof this._version !== 'undefined'
            ? TeaserBox_helpers_1.getArticlesCountPerTab(this._version)
            : undefined;
    }
    /**
     * @inheritDoc
     * @override
     */
    static getInitialConfig() {
        return {
            driver: _contracts_1.ModuleDriver.TeaserBox,
            size: {
                colSpan: 6,
                rowSpan: 2,
                isResizable: false
            },
            version: TeaserBox_contracts_1.TeaserBoxVersion['1XL']
        };
    }
    /**
     * @inheritDoc
     * @override
     */
    static getInitialContent() {
        return {
            additionalRows: _contracts_1.ModuleAdditionalRows.addTwo,
            backgroundColor: _contracts_1.ModuleBackgroundColor.None,
            background: null,
            header: {
                text: '',
                site: '',
                isLink: false,
                isH1: false
            },
            headerLink: null,
            isPremium: false,
            tabs: [],
            titleVersion: '',
            showHeader: true,
            showAuthorAvatar: true,
            showAuthorName: true,
            showCategory: false,
            showArticleTags: false,
            showPublicationDate: false,
            showModuleOnFirstPageOnly: false
        };
    }
    get additionalRowsOptions() {
        return Object.values(_contracts_1.ModuleAdditionalRows)
            .map(value => ({
            label: this.$t(`modules.additionalRows.${value}`),
            value: value
        }));
    }
    get canHaveReadMore() {
        return this._version ? !this.versionWithoutReadMore.includes(this._version) : false;
    }
    get hasMoreThanOneTab() {
        return this._content.tabs && this._content.tabs.length > 1;
    }
    /**
     * Alternative titles options.
     */
    get titleOptions() {
        return [
            {
                label: `${this.$t('forms.shared.titleVersion.none')}`,
                value: ''
            },
            ...Object.values(_contracts_1.TitleVersion).map(value => ({
                label: `${this.$t('forms.shared.titleVersion.' + value)}`,
                value
            }))
        ];
    }
    /**
     * TeaserBox version options.
     */
    get isVersionWithExtension() {
        if (!this._version) {
            return false;
        }
        return this.versionsWithExtendedRows.includes(this._version);
    }
    get isVersionWithoutTabs() {
        if (!this._version) {
            return false;
        }
        return TeaserBox_helpers_1.isTeaserBoxWithoutTabs(this._version);
    }
    get versionOptions() {
        return Object.keys(TeaserBox_contracts_1.TeaserBoxVersion);
    }
    get versionValue() {
        return this._version;
    }
    set versionValue(value) {
        if (!value) {
            return;
        }
        this._version = value;
        if (!this.isVersionWithExtension) {
            this._content.additionalRows = undefined;
        }
    }
    addNewTab() {
        this._content.tabs = [...this._content.tabs, { ...JSON.parse(JSON.stringify(this.newTab)) }];
    }
    deleteReadMore(index) {
        const tabsCopy = [...this._content.tabs];
        delete tabsCopy[index].readMoreLink;
        this._content.tabs = tabsCopy;
    }
    deleteTab(index) {
        if (!this.hasMoreThanOneTab) {
            return;
        }
        const tabsCopy = [...this._content.tabs];
        tabsCopy.splice(index, 1);
        this._content.tabs = tabsCopy;
    }
    findLinkSource(index) {
        this.pickRelated(services_1.Picker.Content, (source) => this.setLinkSource(index, source));
    }
    getIconsClass(variant) {
        return `version-${variant}`;
    }
    hasTabLink(index) {
        if (this._content.tabs[index].readMoreLink && this._content.tabs[index].readMoreLink !== null) {
            return Object.prototype.hasOwnProperty.call(this._content.tabs[index].readMoreLink, 'value');
        }
        return false;
    }
    hasListType(index) {
        return this._content.tabs[index].listType && typeof this._content.tabs[index].listType === 'string' &&
            this._content.tabs[index].listType.length > 0;
    }
    hasTabList(index) {
        return !!this._content.tabs[index].list && this._content.tabs[index].list !== null &&
            typeof this._content.tabs[index].list.value !== 'undefined';
    }
    setListSource(index, source) {
        const tabsCopy = [...this._content.tabs];
        tabsCopy[index].list = source;
        this._content.tabs = tabsCopy;
    }
    setListType(index, type) {
        const tabsCopy = [...this._content.tabs];
        tabsCopy[index].listType = type;
        this._content.tabs = tabsCopy;
    }
    setTabName(index, value) {
        this.debouncedFunc(index, value);
    }
    /**
     * @inheritDoc
     * @override
     */
    setInitialContent() {
        const content = { ...merge_1.default(this.initialContent, this._content) };
        if (content.tabs && content.tabs.length === 0) {
            content.tabs.push(JSON.parse(JSON.stringify(this.newTab)));
        }
        content.tabs = content.tabs.map(tab => {
            // If tab doesn't have allowDuplicates or startFromBeginning add this prop with default value
            return {
                // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
                // @ts-ignore
                allowDuplicates: false,
                // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
                // @ts-ignore
                startFromBeginning: false,
                // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
                // @ts-ignore
                listType: form_2.ListSelectionMode.Default,
                ...tab
            };
        });
        this._content = content;
        if (this._content.headerLink) {
            this.findHeaderLinkSource(this._content.headerLink);
        }
        if (this._content.headerImage) {
            this.findHeaderImageSource(this._content.headerImage);
        }
    }
    findHeaderLinkSource(source) {
        this.describe(source);
    }
    findHeaderImageSource(source) {
        this.describe(source, 'url');
    }
    setLinkSource(index, source) {
        const tabsCopy = [...this._content.tabs];
        tabsCopy[index].readMoreLink = source;
        this.describe(source);
        this._content.tabs = tabsCopy;
    }
};
TeaserBoxModuleForm = TeaserBoxModuleForm_1 = __decorate([
    vue_property_decorator_1.Component({
        name: 'TeaserBoxModuleForm',
        components: {
            DashmixButton: backoffice_1.DashmixButton,
            DashmixInput: backoffice_1.DashmixInput,
            DashmixCheck: backoffice_1.DashmixCheck,
            DashmixSelect: backoffice_1.DashmixSelect,
            FormErrors: form_2.FormErrors,
            ListSelector: form_3.ListSelector,
            LineHeaderForm: form_2.LineHeaderForm,
            SlickList: vue_slicksort_1.SlickList,
            SlickItem: vue_slicksort_1.SlickItem
        },
        created() {
            this.debouncedFunc = debounce_1.default((index, value) => {
                this.debouncedFunc.cancel();
                const content = { ...this._content };
                content.tabs[index].label = value;
                this._content = content;
            }, 1500);
        },
        mounted() {
            this.$nextTick(() => {
                for (let i = 0; i < this._content.tabs.length; i++) {
                    if (this.hasTabLink(i)) {
                        this.describe(this._content.tabs[i].readMoreLink);
                    }
                }
            });
        },
        template: `
    <div>
    <!-- Articles count -->
    <p v-if="typeof articlesCount === 'number'"
       :class="articlesCount === 0 ? 'text-danger' : 'text-success'">
      {{ $t('forms.shared.articlesCount') }}: <b>{{ articlesCount }}</b>
      <span v-if="!isVersionWithoutTabs">
        ({{ articlesCountPerTab }} {{ $t('forms.teaserBox.perEachTab') }})
      </span>
    </p>

    <hr>

    <!-- Version (module variant) -->
    <div class="form-group">
      <label for="version">{{ $t('forms.shared.modulesVariant') }}</label>
      <div class="teaser-box__forms-inputs">
        <template v-for="variant in versionOptions">
          <DashmixCheck class="mx-2 mt-3" type="radio" name="modules-variant"
                        :id="variant" :value="variant" :model.sync="versionValue">
            <i class="teaser-box__form-icon" :class="getIconsClass(variant)"/>
          </DashmixCheck>
        </template>
      </div>

      <div v-if="isVersionWithoutTabs" class="alert alert-warning mt-3">
        <h3 class="alert-heading mb-2">{{ $t('forms.shared.warning') }}</h3>
        {{ $t('forms.teaserBox.variantWithoutTabs') }}
      </div>

      <div class="row" v-if="isVersionWithExtension">
        <div class="form-group col-12 col-md-6 mt-3">
          <label for="rows">{{ $t('forms.shared.additionalRows') }}</label>
          <DashmixSelect :model.sync="_content.additionalRows" name="additionalRows"
                         :placeholder="$t('forms.shared.additionalRowsPlaceholder')"
                         :options="additionalRowsOptions" :searchable="false"/>
        </div>
      </div>
    </div>

    <!-- Heading -->
    <LineHeaderForm :header.sync="_content.header" :headerLink.sync="_content.headerLink"
                    :headerImage.sync="_content.headerImage" :showHeader.sync="_content.showHeader" :canBeImage="true"
                    :pickRelated="pickRelated"
                    :imageDescription="_content.headerImage ? description(_content.headerImage) : ''"
                    :linkDescription="_content.headerLink ? description(_content.headerLink) : ''"
                    @findLinkSource="findHeaderLinkSource" @findImageSource="findHeaderImageSource"/>

    <div class="row">
      <!-- Alternative title -->
      <div class="form-group col-12 col-md-6">
        <label for="version">{{ $t('forms.shared.alternativeTitle') }}</label>
        <DashmixSelect :model.sync="_content.titleVersion" name="titleVersion"
                       :placeholder="$t('forms.shared.iconPlaceholder')"
                       :options="titleOptions" :searchable="false"/>
      </div>

      <!-- Background color -->
      <div class="form-group col-12 col-md-6">
        <label for="color">{{ $t('forms.shared.backgroundColor') }}</label>
        <DashmixSelect :model.sync="_content.backgroundColor" name="backgroundColor"
                       :placeholder="$t('forms.shared.backgroundColorPlaceholder')"
                       :options="backgroundColorOptions" :searchable="false"/>
        <DashmixInput v-if="isCustomColor" type="color" :model.sync="_content.background" name="background"/>
      </div>
    </div>

    <!-- Settings -->
    <div class="form-group">
      <DashmixCheck :label="$t('forms.teaserBox.options.authorAvatar')" name="showAuthorAvatar"
                    :model.sync="_content.showAuthorAvatar"/>

      <DashmixCheck :label="$t('forms.teaserBox.options.authorName')" name="showAuthorName"
                    :model.sync="_content.showAuthorName"/>

      <DashmixCheck :label="$t('forms.teaserBox.options.showCategory')" name="showCategory"
                    :model.sync="_content.showCategory"/>

      <DashmixCheck :label="$t('forms.teaserBox.options.publicationDate')" name="showPublicationDate"
                    :model.sync="_content.showPublicationDate"/>

      <DashmixCheck :label="$t('forms.teaserBox.options.showArticleTags')" name="showArticleTags"
                    :model.sync="_content.showArticleTags"/>

      <DashmixCheck :label="$t('forms.teaserBox.options.showModuleOnFirstPageOnly')" name="showModuleOnFirstPageOnly"
                    :model.sync="_content.showModuleOnFirstPageOnly"/>
    </div>
    <!-- END | Settings -->

    <!-- Tabs -->
    <div class="mb-4">
      <label for="list_value" class="d-block">{{ $t('forms.teaserBox.tabs') }}</label>

      <SlickList v-if="_content.tabs && _content.tabs.length" class="draggable__list p-0"
                 :value="_content.tabs" v-model="_content.tabs"
                 axis="y" lockAxis="y" tag="div"
                 :distance="50" appendTo=".draggable__list"
                 helperClass="draggable__list__helper">
        <SlickItem v-for="(tab, index) in _content.tabs" :index="index" :key="tab.label + '-' + index" tag="div">

          <!-- Single tab -->
          <div class="bg-light py-3 row mx-0 mb-3">
            <div class="col-11">
              <div class="mb-3">
                <template v-if="hasMoreThanOneTab">
                  <label for="list_value" class="d-block">{{ $t('forms.teaserBox.tabName') }}</label>
                  <DashmixInput size="small" :model="tab.label" :name="'tab-label-' + index"
                                @update:model="value => setTabName(index, value)"/>
                </template>

                <DashmixCheck class="pt-2" :label="$t('forms.shared.allowDuplicates')" :name="'allowCopy-' + index"
                              :model.sync="tab.allowDuplicates"/>

                <DashmixCheck :label="$t('forms.shared.startFromBeginning')" :name="'startFromBeginning-' + index"
                              :model.sync="tab.startFromBeginning"/>
              </div>

              <div class="row m-0">
                <div class="col-12 pl-0 mb-3">
                  <p class="mb-2"><b>{{ $t('forms.tile.articlesSource') }}</b></p>

                  <ListSelector :mode="mode" :duplicates="tab.allowDuplicates"
                                :list="hasTabList(index) ? _content.tabs[index].list : null"
                                :listType="_content.tabs[index].listType"
                                @update:list="(r) => setListSource(index, r)"
                                @update:listType="(t) => setListType(index, t)"
                                :pickRelated="pickRelated" :relatedService="relatedService"/>
                </div>

                <div v-if="canHaveReadMore" class="col-12 pl-0">
                  <p class="mb-2"><b v-html="$t('forms.teaserBox.readMore')"></b></p>
                  <div class="row">
                    <template v-if="hasTabLink(index)">
                      <div class="col d-flex align-items-center">
                        <p class="mb-0">
                          <strong class="mr-2">{{ $t('forms.shared.chosenSource') }}</strong>
                          {{ description(tab.readMoreLink) }}
                        </p>
                      </div>
                      <div class="col-3 text-right">
                        <DashmixButton variant="alt" :icon="DashmixIconName.PenSolid" :label="$t('forms.shared.change')"
                                       @click="() => findLinkSource(index)"/>
                        <DashmixButton v-if="hasTabLink(index)" theme="danger" variant="alt"
                                       :icon="DashmixIconName.TrashSolid"
                                       @click="() => deleteReadMore(index)"/>
                      </div>
                    </template>

                    <template v-else>
                      <div class="col-3">
                        <DashmixButton variant="alt" :icon="DashmixIconName.PenSolid" :label="$t('forms.shared.add')"
                                       @click="() => findLinkSource(index)"/>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-1 d-flex align-items-center p-0">
              <DashmixButton v-if="hasMoreThanOneTab" variant="icon" :icon="DashmixIconName.TrashSolid" theme="danger"
                             @click="() => deleteTab(index)"/>
            </div>
          </div>
        </SlickItem>
      </SlickList>

      <!-- Add new tab button -->
      <DashmixButton :label="$t('forms.teaserBox.newTabs')" @click="addNewTab"
                     :icon="DashmixIconName.PlusSolid" variant="icon"/>
    </div>
    <!-- Form errors -->
    <FormErrors v-if="errors" v-bind="{ errors }" class="mt-3"/>
    </div>
  `
    })
], TeaserBoxModuleForm);
exports.TeaserBoxModuleForm = TeaserBoxModuleForm;
//# sourceMappingURL=TeaserBox.form.js.map